import { API_URL, authFetch } from '../components/utils/auth';

async function readJson(response, fallback) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || fallback);
  return data;
}

export async function fetchTeams() {
  const response = await authFetch(`${API_URL}/staff/teams/`);
  return readJson(response, 'Unable to load teams.');
}

export async function fetchTeamCreateOptions(teamType = '') {
  const query = teamType ? `?team_type=${encodeURIComponent(teamType)}` : '';
  const response = await authFetch(`${API_URL}/staff/teams/create-options/${query}`);
  return readJson(response, 'Unable to load team options.');
}

export async function createTeam(payload) {
  const response = await authFetch(`${API_URL}/staff/teams/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return readJson(response, 'Unable to create team.');
}

export async function fetchTeam(teamId) {
  const response = await authFetch(`${API_URL}/staff/teams/${teamId}/`);
  return readJson(response, 'Unable to load team.');
}

export async function renameTeam(teamId, name) {
  const response = await authFetch(`${API_URL}/staff/teams/${teamId}/rename/`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
  return readJson(response, 'Unable to rename team.');
}

export async function submitTeamRating(teamId, payload) {
  const response = await authFetch(`${API_URL}/staff/teams/${teamId}/ratings/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return readJson(response, 'Unable to submit rating.');
}

export async function fetchTeamNotes(teamId) {
  const response = await authFetch(`${API_URL}/staff/teams/${teamId}/notes/`);
  return readJson(response, 'Unable to load team notes.');
}

export async function createTeamNote(teamId, body) {
  const response = await authFetch(`${API_URL}/staff/teams/${teamId}/notes/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ body }),
  });
  return readJson(response, 'Unable to add note.');
}

export async function requestMemberRemoval(teamId, payload) {
  const response = await authFetch(`${API_URL}/staff/teams/${teamId}/personnel-removal-requests/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return readJson(response, 'Unable to submit removal request.');
}

export async function requestEmploymentReview(teamId, payload) {
  const response = await authFetch(`${API_URL}/staff/teams/${teamId}/employment-review-requests/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return readJson(response, 'Unable to submit employment review request.');
}